import { render } from "./PrivacyPolicyAppleAppStore.vue?vue&type=template&id=b199f928&scoped=true"
import script from "./PrivacyPolicyAppleAppStore.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyAppleAppStore.vue?vue&type=script&lang=js"

import "./PrivacyPolicyAppleAppStore.vue?vue&type=style&index=0&id=b199f928&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b199f928"]])

export default __exports__